// Copyright 2021-2022 zcloak authors & contributors
// SPDX-License-Identifier: Apache-2.0

import { Box, Button, Typography } from '@mui/material';

import Logo6 from './icon_builderdao.png';
import Logo21 from './logo_flock.png';
import Logo1 from './logo_moledao.png';
import Logo5 from './logo_mw.png';
import Logo4 from './logo_sfdao.png';
import Logo22 from './logo_tusima.png';
import Logo3 from './logo_web3go.png';

const Partner = () => {
  return (
    <Box display="flex" justifyContent="space-between" width="100%">
      <PartnerItem bg="#fff" link="https://galxe.com/moledao/campaign/GCb4UU4kE4" url={Logo1} />
      <PartnerItem2
        bg="#fff"
        link="https://galxe.com/TusimaNetwork/campaign/GC9swU4wmj"
        url1={Logo21}
        url2={Logo22}
      />
      <PartnerItem bg="#fff" link="https://galxe.com/Web3Go/campaign/GCpBPUwRmW" url={Logo3} />
      <PartnerItem
        bg="#000"
        link="https://galxe.com/SnapFingersDAO/campaign/GC1ZMUwJfk"
        url={Logo4}
      />
      <PartnerItem bg="#000" link="https://galxe.com/MirrorWorld/campaign/GC3M8Uw7TS" url={Logo5} />
      <PartnerItem
        bg="#000"
        link="https://www.vitae3.me/sbt/0xB0B5F27E3D06009cAD24d5865247C7b5acFe0471/1"
        url={Logo6}
      />
    </Box>
  );
};

export default Partner;

const PartnerItem: React.FC<{ url: string; bg: string; link?: string }> = ({ bg, link, url }) => {
  return (
    <Box
      sx={{
        width: '178px',
        height: '160px',
        background: '#E4EEEF',
        border: '1px solid rgba(27,145,150,0.7098)',
        borderRadius: '16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Box
        sx={{
          width: 66,
          height: 66,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: bg
        }}
      >
        <img src={url} />
      </Box>
      {link ? (
        <Button
          onClick={() => {
            window.open(link);
          }}
          sx={{
            color: '#1B9196',
            marginTop: '10px'
          }}
        >
          Go to claim
        </Button>
      ) : (
        <Typography color="#8E8E8E" mt={1}>
          {link ? '' : 'Coming Soon'}
        </Typography>
      )}
    </Box>
  );
};

const PartnerItem2: React.FC<{ url1: string; url2: string; bg: string; link?: string }> = ({
  bg,
  link,
  url1,
  url2
}) => {
  return (
    <Box
      sx={{
        width: '178px',
        height: '160px',
        background: '#E4EEEF',
        border: '1px solid rgba(27,145,150,0.7098)',
        borderRadius: '16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      }}
    >
      <Box
        sx={{
          width: 66,
          height: 66
        }}
      ></Box>
      <Box
        sx={{
          width: 66,
          height: 66,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: bg,
          position: 'absolute',
          top: '30px',
          left: '30px'
        }}
      >
        <img src={url1} />
      </Box>
      <Box
        sx={{
          width: 66,
          height: 66,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: bg,
          position: 'absolute',
          top: '30px',
          right: '30px'
        }}
      >
        <img src={url2} />
      </Box>
      {link ? (
        <Button
          onClick={() => {
            window.open(link);
          }}
          sx={{
            color: '#1B9196',
            marginTop: '10px'
          }}
        >
          Go to claim
        </Button>
      ) : (
        <Typography color="#8E8E8E" mt={1}>
          {link ? '' : 'Coming Soon'}
        </Typography>
      )}
    </Box>
  );
};
